import { TransitionGroup as w, Transition as A, defineComponent as f, openBlock as u, createBlock as p, resolveDynamicComponent as c, unref as l, mergeProps as m, withCtx as g, renderSlot as y } from "vue";
const h = (a) => a.group ? w : A;
function v(a, o) {
  return typeof a == "number" ? a : typeof a == "object" && a !== null ? a[o] ?? 0 : 0;
}
function B(a) {
  return a.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function L(a, o) {
  const e = v(a.duration, "enter"), n = v(a.delay, "enter");
  o.style.setProperty("animation-duration", `${e}ms`), o.style.setProperty("animation-delay", `${n}ms`), _(a, o);
}
function M(a, o) {
  const e = v(a.duration, "leave"), n = v(a.delay, "leave");
  o.style.setProperty("animation-duration", `${e}ms`), o.style.setProperty("animation-delay", `${n}ms`), _(a, o);
}
function F(a, o, e) {
  P(a, o);
  const n = v(a.duration, "leave"), i = v(a.delay, "leave");
  setTimeout(e, n + i);
}
function $(a, o) {
  a.styles && Object.entries(a.styles).forEach(([e]) => {
    if (e in o.style) {
      const n = B(e);
      o.style.removeProperty(n);
    }
  }), o.style.removeProperty("animation-duration"), o.style.removeProperty("animation-delay");
}
function _(a, o) {
  k(a, o), a.styles && Object.entries(a.styles).forEach(([e, n]) => {
    if (e in o.style) {
      const i = B(e);
      o.style.setProperty(i, n);
    }
  });
}
function P(a, o) {
  if (a.group && o instanceof HTMLElement) {
    const e = getComputedStyle(o), { width: n, height: i, marginLeft: r, marginTop: s } = e, t = n !== "auto" ? parseFloat(n) : o.offsetWidth, d = i !== "auto" ? parseFloat(i) : o.offsetHeight, b = parseFloat(r), S = parseFloat(s);
    o.style.setProperty("left", `${o.offsetLeft - b}px`, "important"), o.style.setProperty("top", `${o.offsetTop - S}px`, "important"), o.style.setProperty("width", `${t}px`, "important"), o.style.setProperty("height", `${d}px`, "important"), o.style.setProperty("position", "absolute", "important");
  }
}
function k(a, o) {
  a.origin && o.style.setProperty("transform-origin", a.origin);
}
const T = (a, o) => ({
  onAfterEnter: (e) => {
    $(a, e), o("after-enter", e);
  },
  onAfterLeave: (e) => {
    $(a, e), o("after-leave", e);
  },
  onBeforeEnter: (e) => {
    L(a, e), o("before-enter", e);
  },
  onBeforeLeave: (e) => {
    M(a, e), o("before-leave", e);
  },
  onLeave: (e, n) => {
    F(a, e, n), o("leave", e, n);
  }
}), C = /* @__PURE__ */ f({
  __name: "CollapseTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = {
      onAfterEnter(t) {
        t.style.transition = "", t.style.height = "", t.style.overflow = t.dataset.oldOverflow, n("after-enter", t);
      },
      onAfterLeave(t) {
        t.style.transition = "", t.style.height = "", t.style.overflow = t.dataset.oldOverflow, t.style.paddingTop = t.dataset.oldPaddingTop, t.style.paddingBottom = t.dataset.oldPaddingBottom, n("after-leave", t);
      },
      onBeforeEnter(t) {
        const d = v(e.duration, "enter");
        t.style.transition = s(d), t.dataset || (t.dataset = {}), t.dataset.oldPaddingTop = t.style.paddingTop, t.dataset.oldPaddingBottom = t.style.paddingBottom, t.style.height = "0", t.style.paddingTop = 0, t.style.paddingBottom = 0, _(e, t), n("before-enter", t);
      },
      onBeforeLeave(t) {
        t.dataset || (t.dataset = {}), t.dataset.oldPaddingTop = t.style.paddingTop, t.dataset.oldPaddingBottom = t.style.paddingBottom, t.dataset.oldOverflow = t.style.overflow, t.style.height = `${t.scrollHeight}px`, t.style.overflow = "hidden", _(e, t), n("before-leave", t);
      },
      onEnter(t) {
        t.dataset.oldOverflow = t.style.overflow, t.scrollHeight !== 0 ? (t.style.height = `${t.scrollHeight}px`, t.style.paddingTop = t.dataset.oldPaddingTop, t.style.paddingBottom = t.dataset.oldPaddingBottom) : (t.style.height = "", t.style.paddingTop = t.dataset.oldPaddingTop, t.style.paddingBottom = t.dataset.oldPaddingBottom), t.style.overflow = "hidden";
      },
      onLeave(t, d) {
        const b = v(e.duration, "leave");
        t.scrollHeight !== 0 && (t.style.transition = s(b), t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0), P(e, t), F(e, t, d), n("leave", t, d);
      }
    }, s = (t) => {
      const d = t / 1e3;
      return `${d}s height ease-in-out, ${d}s padding-top ease-in-out, ${d}s padding-bottom ease-in-out`;
    };
    return (t, d) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-collapse"
    }, { ...t.$attrs, ...r }), {
      default: g(() => [
        y(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), Z = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "FadeTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-fade"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), D = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ScaleTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "top left" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-scale"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), E = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "SlideXLeftTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-slide-left"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), O = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "SlideXRightTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-slide-right"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), X = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "SlideYDownTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-slide-down"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), Y = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "SlideYUpTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-slide-up"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), z = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ZoomCenterTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-zoom"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), H = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ZoomUpTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-zoom-up"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), U = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ZoomXTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-zoom-x"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), j = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ZoomYTransition",
  props: {
    delay: { default: 0 },
    duration: { default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { default: "" },
    styles: { default: () => ({
      animationFillMode: "both",
      animationTimingFunction: "ease-out"
    }) },
    tag: { default: "span" }
  },
  emits: ["after-enter", "after-leave", "before-enter", "before-leave", "leave"],
  setup(a, { emit: o }) {
    const e = a, n = o, i = h(e), r = T(e, n);
    return (s, t) => (u(), p(c(l(i)), m({
      tag: e.tag,
      name: "noc-zoom-y"
    }, { ...s.$attrs, ...l(r) }), {
      default: g(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["tag"]));
  }
}), I = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CollapseTransition: C,
  FadeTransition: Z,
  ScaleTransition: D,
  SlideXLeftTransition: E,
  SlideXRightTransition: O,
  SlideYDownTransition: X,
  SlideYUpTransition: Y,
  ZoomCenterTransition: z,
  ZoomUpTransition: H,
  ZoomXTransition: U,
  ZoomYTransition: j
}, Symbol.toStringTag, { value: "Module" }));
function K(a) {
  a.$_vueBezierInstalled || (a.$_vueBezierInstalled = !0, Object.entries(I).forEach(
    ([o, e]) => a.component(o, e)
  ));
}
const W = {
  install: K
};
export {
  C as CollapseTransition,
  Z as FadeTransition,
  D as ScaleTransition,
  E as SlideXLeftTransition,
  O as SlideXRightTransition,
  X as SlideYDownTransition,
  Y as SlideYUpTransition,
  z as ZoomCenterTransition,
  H as ZoomUpTransition,
  U as ZoomXTransition,
  j as ZoomYTransition,
  W as default,
  K as install
};
